document.addEventListener('DOMContentLoaded', () => {
  const trustbox = document.getElementById("trustbox");
  window.Trustpilot.loadFromElement(trustbox);
});
